module.exports = __webpack_public_path__ + "static/media/31b 50-50.61c329d5.jpg";